<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['name']}">
            <label for="name" class="col-sm-2 control-label">Nombre *</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="name" v-model="data.name">
                <div class="help-block" v-for="e in errors['name']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['description']}">
            <label for="description" class="col-sm-2 control-label">Descripción</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="description" v-model="data.description" rows="2"></textarea>
                <div class="help-block" v-for="e in errors['description']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['type']}">
            <label for="type" class="col-sm-2 control-label">Tipo *</label>
            <div class="col-sm-10">
                <el-select filterable clearable v-model="data.type" @change="updatePositions()">
                    <el-option v-for="i in types_topic" :key="i.type_code" :label="i.type_name" :value="i.type_code"></el-option>
                </el-select>
                <div class="help-block" v-for="e in errors['type']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['url']}">
            <label for="url" class="col-sm-2 control-label">URL *</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="url" v-model="data.url" @input="validate()">
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
        </div>
        
        <div v-if="data.type=='aclara-tus-dudas'" class="form-group" :class="{'has-error': errors['icon']}">
            <label for="icon" class="col-sm-2 control-label">Ícono *</label>
            <div class="col-sm-10">
                <!--<input type="text" class="form-control" id="tooltip" v-model="data.icon">-->
                <icon-covid-select id="icon" v-model="data.icon"></icon-covid-select>
                <div class="help-block" v-for="e in errors['icon']">{{e}}</div>
            </div>
        </div>   


        <div v-if="data.type=='beneficios-persona'" class="form-group" :class="{'has-error': errors['icon']}">
            <label for="icon" class="col-sm-2 control-label">Ícono *</label>
            <div class="col-sm-10">
                <!--<input type="text" class="form-control" id="tooltip" v-model="data.icon">-->
                <icon-covid-select id="icon" v-model="data.icon"></icon-covid-select>
                <div class="help-block" v-for="e in errors['icon']">{{e}}</div>
            </div>
        </div>        
        
        <div class="form-group" :class="{'has-error': errors['active']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch :disabled="!data.type" v-model="data.active" on-text="SI" off-text="NO"></el-switch> <span v-if="!data.type">* Debe seleccionar un tipo para poder activar/desactivar </span>
                <div class="help-block" v-for="e in errors['active']">{{e}}</div>
            </div>
        </div>
        <div v-if="data.active" class="form-group" :class="{'has-error': errors['order']}">
            <label for="order" class="col-sm-2 control-label">Posición *</label>
            <div class="col-sm-10">
                <el-select filterable :loading="loading" v-model="data.order">
                    <el-option v-for="c in positions" :label="c.label + '°'" :value="c.value" :key="c.value"></el-option>
                </el-select>
                <!--<input type="number" step="1" class="form-control" id="order" v-model.number="data.order">-->
                <div class="help-block" v-for="e in errors['order']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" v-if="data.type=='aclara-tus-dudas' || data.type=='beneficios-persona'">
            <label class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10">
                <ul class="row cards-grid">

                    <li class="col-12">
                        <a @click.prevent="" :href="'coronavirus/'+data.url" :title="data.name">
                        <article class="card">
                            <div>
                                <span :class="data.icon"></span>
                            </div>
                            <h2>
                                <strong>{{ data.name }}</strong>
                            </h2>

                        </article>
                        </a>
                    </li>
                </ul>
            </div>

        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/faqs/'+this.faq.id">Cancelar</a>
                <button type="submit" class="btn btn-primary" :disabled="disabled">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    
    .el-date-picker{
        display: block;
    }
    .el-select{
        display: block;
    }

    .card * {
        font-weight: normal;
    }
    .cards-grid {
        list-style: none;
        padding: 0px;
        margin: 0px;
    }
    .cards-grid a {
        text-decoration: none;
    }
    *, :after, :before {
        box-sizing: border-box;
    }
    @media (min-width: 992px){
        .col-md-6 {
            width: 50%;
        }
    }
    .cards-grid li {
        list-style: none;
        margin: 0px;
        padding: 0px 10px;
    }
    .cards-grid li article h2 {
        font-family: 'Roboto Slab';
        padding: 100px 0px 10px 0px;
        color: #000;
        font-size: 22px !important;
        padding-right: 120px;

        margin-top: 20px;
        margin-bottom: 10px;
    }
    .cards-grid li article h2 {
        color: #000;
        font-size: 22px!important;
        padding: 20px 120px 30px 0px !important;
    }
    .cards-grid li article h2 strong {
        font-weight: 600!important;
    }
    .cards-grid article.card {
        position: relative;
        max-height: 133px;
        top: 0px;
        transition: top, 0.3s, box-shadow, 0.3s;
    }
    .cards-grid li article {
        height: auto;
    }
    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        width: 550px;
        min-height: 133px;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }

    .cards-grid li article span {
        font-size: 110px;
        position: absolute;
        right: 20px;
        top: 20px;
    }


    @font-face {
        font-family: 'covid';
        src:  url('/fonts/covid.eot?j0o9fh');
        src:  url('/fonts//covid.eot?j0o9fh#iefix') format('embedded-opentype'),
        url('/fonts/covid.ttf?j0o9fh') format('truetype'),
        url('/fonts/covid.woff?j0o9fh') format('woff'),
        url('/fonts/covid.svg?j0o9fh#covid') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: block;
    }
    
    [class^="icon-icon"], [class*=" icon-icon"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'covid' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
    
        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    

    .icon-icon-acc:before {
    content: "\e914";
    color: #e53f40;
  }
  .icon-icon-baby:before {
    content: "\e915";
    color: #e53f40;
  }
  .icon-icon-balance:before {
    content: "\e916";
    color: #e53f40;
  }
  .icon-icon-bike:before {
    content: "\e917";
    color: #e53f40;
  }
  .icon-icon-botiquin:before {
    content: "\e918";
    color: #e53f40;
  }
  .icon-icon-carro:before {
    content: "\e919";
    color: #e53f40;
  }
  .icon-icon-estetoscopio:before {
    content: "\e91a";
    color: #e53f40;
  }
  .icon-icon-fire:before {
    content: "\e91b";
    color: #e53f40;
  }
  .icon-icon-hospital:before {
    content: "\e91c";
    color: #e53f40;
  }
  .icon-icon-hot:before {
    content: "\e91d";
    color: #e53f40;
  }
  .icon-icon-megafono:before {
    content: "\e91e";
    color: #e53f40;
  }
  .icon-icon-nohome:before {
    content: "\e91f";
    color: #e53f40;
  }
  .icon-icon-pen:before {
    content: "\e920";
    color: #e53f40;
  }
  .icon-icon-pig:before {
    content: "\e921";
    color: #e53f40;
  }
  .icon-icon-rain:before {
    content: "\e922";
    color: #e53f40;
  }
  .icon-icon-snow:before {
    content: "\e923";
    color: #e53f40;
  }
  .icon-icon-user-confg:before {
    content: "\e924";
    color: #e53f40;
  }
  .icon-icon-users:before {
    content: "\e925";
    color: #e53f40;
  }
  .icon-icon-vote:before {
    content: "\e926";
    color: #e53f40;
  }
  .icon-icon-abu:before {
    content: "\e927";
    color: #e53f40;
  }
  .icon-huaso:before {
    content: "\e913";
    color: #d0021b;
  }
  .icon-icon-cuarentena:before {
    content: "\e910";
    color: #e53f40;
  }
  .icon-icon-judicial:before {
    content: "\e911";
    color: #e53f40;
  }
  .icon-icon-presencial:before {
    content: "\e912";
    color: #e53f40;
  }
  .icon-icon-sofa:before {
    content: "\e90f";
    color: #e53f40;
  }
  .icon-icon-beneficios:before {
    content: "\e90e";
    color: #e53f40;
  }
  .icon-icon-canasta:before {
    content: "\e90c";
    color: #e53f40;
  }
  .icon-icon-news:before {
    content: "\e90d";
    color: #e53f40;
  }
  .icon-icon-documento:before {
    content: "\e90a";
    color: #e53f40;
  }
  .icon-icon-pyme:before {
    content: "\e90b";
    color: #e53f40;
  }
  .icon-icon-escuela:before {
    content: "\e904";
    color: #e53f40;
  }
  .icon-icon-estudio:before {
    content: "\e905";
    color: #e53f40;
  }
  .icon-icon-migracion:before {
    content: "\e906";
    color: #e53f40;
  }
  .icon-icon-salud:before {
    content: "\e907";
    color: #e53f40;
  }
  .icon-icon-trabajo:before {
    content: "\e908";
    color: #e53f40;
  }
  .icon-icon-viaje:before {
    content: "\e909";
    color: #e53f40;
  }
  .icon-icon-flecha:before {
    content: "\e903";
    color: #e53f40;
  }
  .icon-icon-coronavirus-blanco:before {
    content: "\e902";
    color: #fff;
  }
  .icon-icon-escudo:before {
    content: "\e900";
    color: #e53f40;
  }
  .icon-icon-coronavirus:before {
    content: "\e901";
    color: #e53f40;
  }
  
</style>
<script>
    import Vue from 'vue';
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';
    import IconCovidSelect from './IconCovidSelect.vue';
    import { Message } from "element-ui";
    import { Loading } from 'element-ui';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                name: '',
                description: '',
                type: null,
                url: '',
                active: false,
                icon: '',
                order: null,
                created_at: null,
                updated_at: null,
                deleted_at: null
            };
            
            return{
                data: _.assign(data, this.topic),
                disabled: false,
                must_delete: false,
                errors: {},
                positions: [],
                loading: false
            }
        },
        props: ['faq','topic', 'total_topics_dudas', 'total_topics_debes_saber','edit','total_topics_beneficios' , 'types_topic'],
        computed: {
            types: function(){
                var list = [];
                const set = new Set(['aclara-tus-dudas','lo-que-debes-saber','beneficios-persona']);
                list = Array.from(set);
                return list;
            },
             positionsBeneficios: function(){
                var self = this;
                var positions = [];

                var i = 1;
                var len = self.total_topics_beneficios;
                for (; i <= len+1; ) {
                    var position = {value:i, label: i.toString()};
                    positions.push(position);
                    i++;
                }

                return positions;
            },

            positionsDudas: function(){
                var self = this;
                var positions = [];

                var i = 1;
                var len = self.total_topics_dudas;
                for (; i <= len+1; ) {
                    var position = {value:i, label: i.toString()};
                    positions.push(position);
                    i++;
                }

                return positions;
            },
            positionsDebesSaber: function(){
                var self = this;
                var positions = [];

                var i = 1;
                var len = self.total_topics_debes_saber;
                for (; i <= len+1; ) {
                    var position = {value:i, label: i.toString()};
                    positions.push(position);
                    i++;
                }

                return positions;
            }
        },
        methods:{
            updatePositions: function() {

                if(this.data.type == 'aclara-tus-dudas'){
                    this.positions = this.positionsDudas;
                }
                if(this.data.type == 'beneficios-persona'){
                    this.positions = this.positionsBeneficios;
                }
                if(this.data.type == 'lo-que-debes-saber'){
                    this.positions = this.positionsDebesSaber;
                }
            },
            validate: function(){
                var self = this;
                delete self.errors.url;
                self.disabled = false;
                
                axios({
                    url: 'backend/faqs/validate_url',
                    method: 'POST',
                    data: self.data,
                }).then(function(response){
                    if(response.data.resp_code == 'NOK'){
                        var errores = {};
                        errores["url"] = [response.data.resp_msg];
                        self.errors = errores;
                        self.disabled = true;
                    }
                }).catch(function(error){
                    var errores = {};
                    errores["url"] = ["No fue posible validar url ingresada. Intente nuevamente."];
                    self.errors = errores;
                    self.disabled = true;
                });
                
            },
            submit: function(){
                var self = this;


                var errores = {};

                if (!self.data.name || self.data.name.length == 0) {
                    errores["name"] = ["Debe ingresar el Nombre de la nueva Categoría."];
                }

                if (!self.data.type || self.data.type.length == 0) {
                    errores["type"] = ["Debe seleccionar un tipo de Categoría."];
                }

                if (!self.data.url || self.data.url.length == 0) {
                    errores["url"] = ["Debe ingresar una url para la categoría."];
                }else{
                    if(self.data.url.substring(0,1) == '/'){
                        errores["url"] = ["Campo URL no debe comenzar con '/' dado que son url internas."];
                    }else{
                        if(self.data.url.indexOf('/') > -1){

                            errores["url"] = ["No se admiten subniveles de URL (/) dentro de esta personalización."];
                        }
                    }
                }

                if (!self.data.icon || self.data.icon.length == 0) {
                    if(self.data.type == 'aclara-tus-dudas'){
                        errores["icon"] = ["Debe seleccionar un ícono."];
                    }
                }

                if (!self.data.order && self.data.active) {
                    errores["order"] = ["Debe seleccionar una posición."];
                }

                if (_.size(errores) > 0 || self.disabled == true) {

                    self.errors = errores;
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }else{
                    axios({
                        url: self.edit ? 'backend/faqs/'+self.faq.id+'/topics/'+self.data.id : 'backend/faqs/'+self.faq.id+'/topics/',
                        method: self.edit ? 'PUT' : 'POST',
                        data: self.data,
                    }).then(function(response){
                        self.$loading().close();
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        self.$loading().close();

                        self.errors = error.response.data.errors;
                    });
                }
            },
        },
        components:{
            ElSelect,
            ElOption,
            IconCovidSelect
        },
        mounted() {
            if(this.edit){
                this.updatePositions();
            }

        }
    }
</script>